import { ActionTypeEnum } from '../ActionTypeEnum';

/**
 *
 *
 * @param {Phone Number} payload
 * @param {Nothing} meta
 * @return return New Status or Object of SMS
 */
const sendSMSActionRequest = (payload, meta) => ({
	type: ActionTypeEnum.sendSMS_request,
	payload,
	meta,
});

const sendSMSActionSuccess = (payload) => ({
	type: ActionTypeEnum.sendSMS_success,
	payload,
});

export { sendSMSActionRequest, sendSMSActionSuccess };
